import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import loanoutaction from "../../context/action/company/loanoutaction";

const Loanbackmodal = (props) => {
  const { initState, recaller, setrecaller, clear, initDispatch } =
    useContext(GlobalContext);

  const [amount, setamount] = useState();
  const [loan_out_discount, setloan_out_discount] = useState();
  const [note, setnote] = useState();
  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);
  return (
    <>
      {props.show ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none p-4">
            <div className="relative my-2 sm:my-4 md:my-6 mx-auto w-full sm:w-2/3 md:w-1/2 lg:w-2/5">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/* Header */}
                <div className="flex items-center justify-between p-3 sm:p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-xl sm:text-2xl md:text-3xl uppercase font-semibold flex-1">
                    گێڕانەوەی قەرز
                  </h3>
                  <button
                    className="p-1 ml-auto text-black opacity-80 text-2xl sm:text-3xl leading-none font-semibold"
                    onClick={() => props.setshow(false)}
                  >
                    <span className="block">X</span>
                  </button>
                </div>

                {/* Body */}
                <div className="relative p-4 sm:p-6 flex-auto">
                  <div className="flex flex-col gap-4">
                    {/* Amount Input */}
                    <div className="w-full">
                      <label
                        className={`block uppercase tracking-wide text-xs font-bold mb-2
                          ${error ? "text-red-500" : "text-gray-700"}`}
                        htmlFor="amount"
                      >
                        بڕی پارە
                      </label>
                      <input
                        className={`appearance-none block w-full bg-gray-50 
                          text-gray-700 border rounded py-2 sm:py-3 px-3 sm:px-4 
                          leading-tight transition duration-150 ease-in-out
                          focus:outline-none focus:bg-white focus:border-gray-500
                          ${error ? "border-red-500" : "border-gray-200"}`}
                        id="amount"
                        type="number"
                        value={amount}
                        onChange={(val) => setamount(val.target.value)}
                        onFocus={() => seterror(false)}
                      />
                    </div>

                    {/* Discount Input */}
                    <div className="w-full">
                      <label
                        className={`block uppercase tracking-wide text-xs font-bold mb-2
                          ${error1 ? "text-red-500" : "text-gray-700"}`}
                        htmlFor="loan_out_discount"
                      >
                        داشکاندن
                      </label>
                      <input
                        className={`appearance-none block w-full bg-gray-50 
                          text-gray-700 border rounded py-2 sm:py-3 px-3 sm:px-4 
                          leading-tight transition duration-150 ease-in-out
                          focus:outline-none focus:bg-white focus:border-gray-500
                          ${error1 ? "border-red-500" : "border-gray-200"}`}
                        id="loan_out_discount"
                        type="number"
                        value={loan_out_discount}
                        onChange={(val) => setloan_out_discount(val.target.value)}
                        onFocus={() => seterror1(false)}
                      />
                    </div>

                    {/* Note Input */}
                    <div className="w-full">
                      <label
                        className="block uppercase tracking-wide text-xs font-bold mb-2 text-gray-700"
                        htmlFor="note"
                      >
                        تێبینی
                      </label>
                      <input
                        className="appearance-none block w-full bg-gray-50 
                          text-gray-700 border border-gray-200 rounded 
                          py-2 sm:py-3 px-3 sm:px-4 
                          leading-tight transition duration-150 ease-in-out
                          focus:outline-none focus:bg-white focus:border-gray-500"
                        id="note"
                        type="text"
                        value={note}
                        onChange={(val) => setnote(val.target.value)}
                      />
                    </div>
                  </div>
                </div>

                {/* Footer */}
                <div className="flex flex-wrap sm:flex-nowrap items-center justify-end gap-2 p-3 sm:p-6 border-t border-solid border-slate-200 rounded-b">
                  <button
                    className="w-full sm:w-auto bg-red-500 text-white active:bg-red-600 
                      font-bold uppercase text-sm px-4 sm:px-6 py-2 sm:py-3 rounded 
                      shadow hover:shadow-lg transition-all duration-150"
                    onClick={() => props.setshow(false)}
                  >
                    داخستن
                  </button>
                  <button
                    className="w-full sm:w-auto bg-emerald-500 text-white active:bg-emerald-600 
                      font-bold uppercase text-sm px-4 sm:px-6 py-2 sm:py-3 rounded 
                      shadow hover:shadow-lg transition-all duration-150"
                    onClick={() => {
                      if (amount < 1 || !amount) {
                        seterror(true);
                        return false;
                      }
                      if (loan_out_discount < 0 || !loan_out_discount) {
                        seterror1(true);
                        return false;
                      }
                      loanoutaction(
                        amount,
                        loan_out_discount,
                        note,
                        props.company_id,
                        initState.token.id
                      )(recaller)(setrecaller)(initDispatch)(clear);
                    }}
                  >
                    ناردن
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default Loanbackmodal;
